import { render, staticRenderFns } from "./BranchTransferList.vue?vue&type=template&id=b0643972&"
import script from "./BranchTransferList.vue?vue&type=script&lang=js&"
export * from "./BranchTransferList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports